<template>
  <div class="points-mall route-scroll">
    <div class="introduce" @click="toIntroduce">
      <img :src="xh" />
      <span>广东省医药质量管理协会</span>
    </div>
    <pull-refresh v-model="pullLoading" @refresh="pullLoadData" :disabled="setClinicVisible">
      <!-- setClinic弹窗打开时 pull-refresh禁止触发下拉刷新 -->
      <setClinic
        @refresh="loadData"
        ref="setClinic"
        immediate
        @open="setClinicVisible = true"
        @close="setClinicVisible = false"
      />
      <mallSearch />
      <!-- 轮播图区域 -->
      <div class="swiper-wrapper" v-if="swiperList.length">
        <van-swipe :autoplay="3000" @change="onSwipeChange" class="mall-swipe">
          <van-swipe-item v-for="(item, index) in swiperList" :key="index" @click="toDetail(item.bannerContent)">
            <img class="swiper-img" :src="item.imageUrl" />
          </van-swipe-item>
        </van-swipe>
      </div>

      <!-- 公告栏 -->
      <div class="notice-panel" v-if="notices.length">
        <van-notice-bar left-icon="volume-o" :scrollable="false">
          <van-swipe vertical :autoplay="5000" :touchable="false" :show-indicators="false" class="notice-swipe">
            <van-swipe-item v-for="(text, index) in notices" :key="index">
              {{ text }}
            </van-swipe-item>
          </van-swipe>
        </van-notice-bar>
      </div>

      <!-- 功能入口 -->
      <!-- <div class="func-panel">
      <div class="func-scroll">
        <div v-for="item in funcList" :key="item.id" class="func-item">
          <van-icon :name="item.icon" size="24px" />
          <span class="func-text">{{ item.text }}</span>
        </div>
      </div>
    </div> -->
      <div class="ach-header" @click="toPointsDetail">
        <div v-if="isVisitor">
          <p class="ach-title">总积分 <span>（以实际激活为准）</span></p>
          <p class="ach-num">5000</p>
        </div>
        <div v-else>
          <p class="ach-title">总积分</p>
          <p class="ach-num"><countTo separator="" :startVal="totalPoints" :endVal="totalPoints" /></p>
        </div>
        <!-- <div>
        <p class="ach-title">积分失效时间</p>
        <p class="ach-num"><countTo separator="" :startVal="0" :endVal="pointsInfo.lmSalseAmount" /></p>
      </div> -->
      </div>

      <!-- 分类导航 -->
      <div class="category-nav" v-if="categoryList.length">
        <div class="category-item" v-for="(item, idx) in categoryList" :key="idx" @click="toCategory(item)">
          <img :src="item.icon" class="category-icon" />
          <div class="category-name">{{ item.navName }}</div>
        </div>
      </div>

      <!-- 限时折扣 -->
      <div class="discount-panel">
        <div class="tabs-warp">
          <span
            v-for="(item, index) in tabList"
            :key="index"
            :class="[active === index ? 'active' : '', 'tabs-item']"
            @click="active = index"
          >
            {{ item.zoneName }}
          </span>
        </div>
        <tabs v-model="active" v-if="false">
          <tab v-for="(item, index) in tabList" :key="index" :title="item.name" />
        </tabs>
        <!-- <div class="panel-header">
        <h3>热门</h3>
        <span class="more" @click="toMore">查看更多<van-icon name="arrow" /></span>
      </div> -->
        <div class="goods-grid">
          <div v-for="goods in discountGoods" :key="goods.id" class="goods-item" @click="toDetail(goods.drugsId)">
            <div class="goods-img">
              <van-image
                v-if="goods.drugsImage"
                :src="goods.drugsImage.split(',')[0]"
                class="goods-cover"
                fit="cover"
              />
            </div>
            <div style="padding: 8px 0 0 8px;min-height: 40px;"><drugTag :product="goods" /></div>
            <pointPrice :product="goods" homeStyle />
          </div>
        </div>

        <van-empty
          v-if="!discountGoods.length"
          class="custom-image"
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="暂无商品"
          image-size="80"
        />
      </div>
    </pull-refresh>

    <tabbar :curIndex="0" />
  </div>
</template>

<script>
import pointPrice from '@/components/pointPrice';
import drugTag from '@/components/drugTag';
import mallSearch from '@/components/mallSearch';
import tabbar from '../components/tabbar';
import { Swipe, SwipeItem, NoticeBar, Image as VanImage, Icon, Tab, Tabs, PullRefresh, Empty } from 'vant';
import services from '@/service';
import countTo from 'vue-count-to';
import { routerPush, notRequest } from '@/lib/utils';
import { mapGetters } from 'vuex';
import setClinic from './components/setClinic';

import xh from '@/assets/img/xh.png';

export default {
  name: 'mallHome',
  components: {
    setClinic,
    pointPrice,
    drugTag,
    mallSearch,
    tabbar,
    countTo,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [NoticeBar.name]: NoticeBar,
    [VanImage.name]: VanImage,
    [Icon.name]: Icon,
    Tab,
    Tabs,
    PullRefresh,
    [Empty.name]: Empty
  },
  data() {
    return {
      setClinicVisible: false,
      pullLoading: false,
      xh,
      swiperList: [],
      currentSwipe: 0,
      notices: [],
      pointsInfo: {
        memberPoints: 0,
        consumptionPoints: 0
      },
      funcList: [
        { id: 1, icon: 'apps-o', text: '分类' },
        { id: 2, icon: 'discount', text: '折扣' },
        { id: 3, icon: 'orders-o', text: '订单' },
        { id: 4, icon: 'gold-coin', text: '积分' },
        { id: 5, icon: 'gift-o', text: '福利' }
      ],
      discountGoods: [],
      userPoints: {},
      bannerList: [],
      active: 0,
      tabList: [],
      categoryList: [],
      indexZone: []
    };
  },
  watch: {
    active: {
      handler() {
        this.loadGoods();
      }
    }
  },
  computed: {
    ...mapGetters(['mallInfo']),

    pageInit() {
      return !notRequest();
    },
    totalPoints() {
      return Number((this.pointsInfo.memberPoints + this.pointsInfo.consumptionPoints).toFixed(0));
    },
    isVisitor() {
      return this.pointsInfo.visitor;
    }
  },
  async mounted() {},
  methods: {
    toIntroduce() {
      this.$router.push({
        name: 'mallIntroduce'
      });
    },
    toSearch() {
      this.$router.push({
        name: 'mallSearch'
      });
    },
    async getBanner() {
      const res = await services.common.getBanner(4);
      this.swiperList = res.data;
    },
    async getNav() {
      const res = await services.mall.getNav(this.$store.getters.curClinicId);
      this.categoryList = res.data.filter(item => item.status === '0');
    },
    async getIndexZone() {
      const res = await services.mall.getIndexZone();
      this.tabList = res.data.filter(item => item.zoneStatus === '0');
      this.loadGoods();
    },
    toMore() {
      this.$router.push({
        name: 'mallCategory'
      });
    },
    toDetail(id) {
      if (!id) return;
      this.$router.push({
        name: 'mallProductDetail',
        query: {
          id
        }
      });
    },
    toPointsDetail() {
      if (this.isVisitor) {
        return this.$toast('请联系企微客服进行激活');
      }
      routerPush({
        name: 'mallPointsDetails'
      });
    },
    onSwipeChange(index) {
      this.currentSwipe = index % 4;
    },
    async pullLoadData() {
      this.pullLoading = true;
      await this.loadData();
      this.pullLoading = false;
    },
    async loadData() {
      await Promise.all([this.getBanner(), this.getNav(), this.getIndexZone()]);
      if (!this.pageInit) return;

      this.pointsInfo = (await services.mall.userPoints()).data;

      if (this.pointsInfo.expiringPointsDate) {
        this.notices.push(`${this.pointsInfo.expiringPoints} 积分将于 ${this.pointsInfo.expiringPointsDate} 失效`);
      }
    },
    async loadGoods() {
      const res = await services.mall.getZoneTypeMall(this.tabList[this.active].zoneType);
      this.discountGoods = res.data;
    },
    realPrice(goods) {
      return (goods.price - goods.memberDeduction).toFixed(2);
    },
    toCategory(item) {
      this.$router.push({
        name: 'mallCategoryList',
        query: { navId: item.navId }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.introduce {
  @include flex(row);
  align-items: center;
  justify-content: center;
  padding: 4px $lr 4px;
  background: #fff;
  color: $gray1;
  font-size: 12px;
  text-align: center;

  img {
    width: 18px;
    height: 18px;
    margin-right: 4px;
  }
}

.points-mall {
  background: #ebf3f5;

  // padding-bottom: 50px;

  .swiper-wrapper {
    height: 160px;
    position: relative;
    padding: 6px $lr 0;

    .mall-swipe {
      height: 100%;
      position: relative;
      z-index: 1;
      border-radius: $radius;

      .swiper-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  .notice-panel {
    margin: 16px;
    border-radius: $radius;
    overflow: hidden;
    // box-shadow: $box-shadow1;

    ::v-deep .van-notice-bar {
      // padding: 10px 16px;

      .notice-swipe {
        height: 16px;
        line-height: 16px;
      }
    }
  }

  .func-panel {
    padding: $tb $lr;
    background: #fff;
    margin: $tb $lr;
    border-radius: $radius;

    .func-scroll {
      display: flex;
      @include flex(row);
      justify-content: space-around;

      .func-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        .func-text {
          font-size: 12px;
          color: $gray1;
          margin-top: 8px;
        }
      }
    }
  }

  .ach-header {
    background: url('../../../assets/img/pointBg.png');
    background-size: 100% 100%;
    padding: 10px $lr;
    margin: $tb $lr;
    border-radius: $radius;
    display: flex;
    justify-content: space-around;
    color: #fff;

    > div {
      flex: 1;
      text-align: center;
    }
    .ach-title {
      font-size: $size6;
    }
    .ach-num {
      font-size: 22px;
      padding-top: 8px;
    }
  }

  .discount-panel {
    margin: 20px 0;

    .tabs-warp {
      @include flex(row);
      justify-content: space-around;
      font-size: $size6;
      margin-top: 20px;
      height: 16px;

      .tabs-item {
        position: relative;
        color: $gray2;
        transition-duration: 0.3s;
      }

      .tabs-item.active {
        color: $gray1;
        font-size: $size4;
        font-weight: 600;

        &::before {
          position: absolute;
          display: inline-block;
          content: '';
          width: 60%;
          height: 6px;
          background: -webkit-linear-gradient(left, $appcolor, lighten($appcolor, 40%));

          bottom: -8px;
          margin-left: 50%;
          left: -30%;
          border-radius: 10px 0 10px 0;
        }
      }
    }

    .panel-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;

      h3 {
        font-size: 18px;
        color: $appcolor;
        font-weight: 700;
      }

      .more {
        font-size: 13px;
        color: $gray2;

        .van-icon {
          margin-left: 4px;
        }
      }
    }

    .goods-grid {
      margin: $tb $lr;
      margin-top: 20px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;

      .goods-item {
        background: #fff;
        border-radius: 8px;
        // box-shadow: $box-shadow1;
        overflow: hidden;

        .goods-img {
          width: 100%;
          aspect-ratio: 1/1;
        }

        .goods-cover {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .goods-title {
          font-size: 14px;
          margin: 8px 12px;
          @include hiddenText();
        }

        .goods-points {
          padding: 0 12px 12px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .points {
            font-size: 12px;
            color: $gray1;
          }

          .price {
            font-size: $size5;
            color: $red1;
            font-weight: 500;
          }
        }
      }
    }
  }

  .category-nav {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 10px 4px 0 4px;
    margin: $tb $lr;
    border-radius: $radius;
    background: #fff;

    .category-item {
      width: 20%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 18px;
      cursor: pointer;

      .category-icon {
        width: 48px;
        height: 48px;
        object-fit: contain;
        margin-bottom: 6px;
      }
      .category-name {
        font-size: 14px;
        color: #222;
        text-align: center;
        white-space: nowrap;
      }
    }
  }
}
</style>
